const SERVER_TIMEZONE_OFFSET = '-06:00'; // Mexico City fijo desde 2022 (sin DST)
// const getBrowserTimezone = () => 'Europe/Madrid';
/**
 * Parsea la fecha del servidor interpretándola como America/Mexico_City
 * y devuelve un Date en la zona horaria del navegador
 */
const toLocalDate = (dateString) => {
  if (!dateString) return null;
  const normalizedDate = String(dateString).trim();
  const hasTimezone = /([zZ]|[+-]\d{2}:\d{2})$/.test(normalizedDate);

  const dateWithTimezone = hasTimezone
    ? normalizedDate
    : `${normalizedDate}${SERVER_TIMEZONE_OFFSET}`;

  const parsedDate = new Date(dateWithTimezone);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const getChatDayKey = (dateString) => {
  const localDate = toLocalDate(dateString);
  if (!localDate) return '';

  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const day = String(localDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const formatChatDateDivider = (dateString) => {
  const localDate = toLocalDate(dateString);
  if (!localDate) return '';

  return localDate.toLocaleDateString(navigator.language, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export const formatChatTimestamp = (dateString) => {
  if (!dateString) return '';
  const localDate = toLocalDate(dateString);
  if (!localDate) {
    return '';
  }

  const now = new Date();

  const isToday =
    localDate.getDate()     === now.getDate()     &&
    localDate.getMonth()    === now.getMonth()     &&
    localDate.getFullYear() === now.getFullYear();

  if (isToday) {
    return localDate.toLocaleTimeString(navigator.language, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }

  return (
    localDate.toLocaleDateString(navigator.language, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }) +
    ', ' +
    localDate.toLocaleTimeString(navigator.language, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  );
};

export const formatToLocalTimezone = (dateString, options = {}, locale = navigator.language) => {
  if (!dateString) return '';
  const localDate = toLocalDate(dateString);
  if (!localDate) {
    return 'Fecha inválida';
  }

  return localDate.toLocaleString(locale, {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
    ...options,
  });
};